export default "__VITE_ASSET__BDgt7msx__"